import Calendar from './Calendar';
export default Calendar;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/index.js